import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BalanceSheetState {
  loading: boolean;
  error: string | null;
  data: any[];
}

const initialState: BalanceSheetState = {
  loading: true,
  error: null,
  data: [],
};

const balanceSheetSlice = createSlice({
  name: 'balanceSheet',
  initialState,
  reducers: {
    setBalanceSheetData: (state, action: PayloadAction<any>) => {
      state.loading = false;
      if (action.payload && !action.payload.error) {
        state.data = Array.isArray(action.payload.data) ? action.payload.data : (action.payload.data?.data || []);
        state.error = null;
      } else {
        state.data = [];
        state.error = action.payload?.data?.message || 'Error fetching balance sheet data';
      }
    },
    resetBalanceSheetState: (state) => {
      state.loading = true;
      state.error = null;
      state.data = [];
    },
  },
});

export const { setBalanceSheetData, resetBalanceSheetState } = balanceSheetSlice.actions;
export default balanceSheetSlice.reducer; 